import { render } from "./DependencyResultPanel.vue?vue&type=template&id=ffc656fc"
import script from "./DependencyResultPanel.vue?vue&type=script&lang=js"
export * from "./DependencyResultPanel.vue?vue&type=script&lang=js"

import "./DependencyResultPanel.vue?vue&type=style&index=0&id=ffc656fc&lang=scss"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__